import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { publicMethods, baseUrl } from '../globals';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class PushMessagesService {
  messages = [];
  popupMsg: Record<string, any> = {};
  showPopupPushMsg = signal(false);

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService,
    private cookieservice: CookieService,
    private pubMethods: publicMethods
  ) {}

  getUserMessages(): void {
    const zintCachedPushMessages = this.pubMethods.getAndParseCookie(
      'zintCachedPushMessages'
    );
    const messagesAreHidden = this.pubMethods.getAndParseCookie(
      'zintHidePushMessagingWindow',
      false
    );
    if (!zintCachedPushMessages && !messagesAreHidden) {
      this.getUserMessagesFromEndpoint().subscribe(data =>
        this.updateUserMessages(data)
      );
    } else {
      this.handlePopupMessages(zintCachedPushMessages);
    }
  }

  handlePopupMessages(messages: any[]): void {
    if (!this.messages) return;
    const hidePopupForSession = JSON.parse(
      window.sessionStorage.getItem('hideMajorPopup')
    );

    if (hidePopupForSession) return;

    this.messages = messages;
    const popupMessages = this.messages?.filter(
      msgObj => msgObj.is_popup === true
    );
    if (popupMessages?.length) {
      this.showPopupPushMsg.set(true);
      this.popupMsg = popupMessages[0];
    }
  }

  getUserMessagesFromEndpoint(): Observable<any> {
    return this.http
      .post(
        baseUrl + '/get_user_messages/',
        '',
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => _),
        catchError(this.pubMethods.handleError('getUserMessages', []))
      );
  }

  updateUserMessages(data): void {
    if (data?.messages?.length) {
      const d = new Date();
      // cache messages for 2 hour
      d.setSeconds(60 * 60 * 2);

      this.pubMethods.setCookieAndExpiry({
        name: 'zintCachedPushMessages',
        value: data.messages,
        expiry: d,
      });
    }
    if (data.messages) {
      this.handlePopupMessages(data.messages);
    }
  }

  ignorePushMessage(msg): Observable<any> {
    let _params = new HttpParams().set('id', msg.id).set('type', msg.type);
    return this.http
      .post(
        baseUrl + '/ignore_push_message/',
        _params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => _),
        catchError(this.pubMethods.handleError('ignorePushMessage', []))
      );
  }

  triggerIgnoreMsg(msg: Record<string, any>): void {
    this.ignorePushMessage(msg).subscribe(data => {
      if (data.success) {
        this.deleteCachedPushMessages();
        this.getUserMessagesFromEndpoint().subscribe(data =>
          this.updateUserMessages(data)
        );
      }
    });
  }

  closePopupWindow(): void {
    window.sessionStorage.setItem('hideMajorPopup', 'true');
  }

  deleteCachedPushMessages(): void {
    this.cookieservice.remove('zintCachedPushMessages');
    this.cookieservice.remove('zintHidePushMessagingWindow');
  }
}
